import { jsx as _jsx } from "react/jsx-runtime";
import { Svg, Circle } from './styles';
export var appearanceToColorMap = {
    error: 'red1',
    concept: 'bgLightGray1',
    done: 'darkGreen',
    info: 'lightGray6',
    processing: 'blue2',
    success: 'green',
    warning: 'yellow1',
    waiting: 'gray1',
};
export var appearanceToFontColorMap = {
    error: 'white',
    concept: 'blue2',
    done: 'white',
    info: 'blue2',
    processing: 'white',
    success: 'white',
    warning: 'blue2',
    waiting: 'white',
};
export var Spinner = function (_a) {
    var _b = _a.variant, variant = _b === void 0 ? 'default' : _b, appearance = _a.appearance;
    var color = appearance ? appearanceToFontColorMap[appearance] : 'blue2';
    return (_jsx(Svg, { viewBox: "22 22 44 44", "$variant": variant, children: _jsx(Circle, { cx: "44", cy: "44", r: "20.2", fill: "none", strokeWidth: "3.6", color: color }) }));
};
export default Spinner;
